import { AxiosError } from 'axios';
import instance from '../config/axios';

export const removeWishList = async (token: string, wishListId: number) => {
  try {
    const response = await instance.delete(
      `/api/v1/remove/whislist-product/${wishListId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (err) {
    console.error(err);
    return (err as AxiosError).response?.status as number;
  }
};
